import React from "react";
import { useSidebar } from "../../context/SidebarContext";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const { isCollapsed } = useSidebar();

  const isAuthPage =
    location.pathname === "/" || location.pathname === "/signup";

  // Sidebar margin only applies on medium+ screens
  const footerStyle = isAuthPage
    ? "ml-0"
    : isCollapsed
    ? "md:ml-20 ml-0"
    : "md:ml-64 ml-0";

  return (
    <footer
      className={`bg-gray-900 text-gray-300 py-4 mt-6 transition-all duration-300 ${footerStyle}`}
    >
      <div className="container mx-auto px-4 
                      flex flex-col gap-2 
                      text-center
                      md:flex-row md:justify-between md:items-center md:text-left">

        <p className="text-sm">
          Hospital Management System{" "}
          <span className="text-green-400">v2.3.4</span>
        </p>

        <p className="text-sm">
          Secure • Reliable • Integrated Healthcare Platform
        </p>

        <p className="text-sm">
          © 2026 <span className="font-semibold text-green-400">
            Humble Software Solution
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
